<h2 mat-dialog-title>
  <mat-icon>bookmark</mat-icon>
  {{ data.type == 'upload' ? 'Cargar documento' : 'Descargar documento' }}
</h2>

@if (data.type === 'upload') {
  <mat-dialog-content class="mat-typography">
    <div class="modal-info">
      <p>Seleccionar los archivos deseados (imágenes o PDFs)</p>
    </div>
    <div class="modal-inputs">
      <input
        type="file"
        class="file-input"
        accept="image/*,application/pdf"
        (change)="onFileSelected($event)"
        #fileUpload
        multiple>
      <br>
        <button mat-mini-fab color="primary" class="upload-btn" (click)="fileUpload.click()">
          <mat-icon>attach_file</mat-icon>
        </button>
        <div class="file-upload">
          @if (fileName.length === 0) {
            <span>No se han agregado archivos.</span>
          }
          @if (fileName.length > 0) {
            <ul>
              @for (name of fileName; track name; let i = $index) {
                <li>
                  <mat-icon class="file-icon">
                    {{ isPdf(urls[i], i) ? 'picture_as_pdf' : 'image' }}
                  </mat-icon>
                  {{ name }}
                </li>
              }
            </ul>
          }
        </div>
        <!-- Preview de archivos -->
        <div class="container">
          @for (url of urls; track url; let i = $index) {
            <div class="image_grp">
              <!-- Si es PDF, mostrar iframe -->
              @if (pdfUrls[i]) {
                <div class="pdf-preview">
                  <iframe
                    [src]="pdfUrls[i]"
                    width="100%"
                    height="200"
                    frameborder="0">
                  </iframe>
                  <div class="file-label">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>{{ fileName[i] }}</span>
                  </div>
                </div>
              } @else {
                <img [src]="url" height="100" alt="Preview">
              }
              <!-- Si es imagen, mostrar img -->
              <button class="btn" (click)="_removeImage(i)" mat-icon-button color="warn">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </mat-dialog-content>
  }

  @if (data.type === 'download') {
    <mat-dialog-content class="mat-typography">
      <div class="modal-info">
        <p>Documentos del mantenimiento</p>
      </div>
      @if (urls.length === 0) {
        <div class="no-files">
          <mat-icon color="accent">folder_open</mat-icon>
          <p>No hay documentos disponibles para este mantenimiento</p>
        </div>
      }
      @if (urls.length > 0) {
        <div class="pdf-viewer-container">
          @for (url of urls; track url; let i = $index) {
            <div class="pdf-item">
              <!-- Para PDFs -->
              @if (pdfUrls[i]) {
                <div class="pdf-wrapper">
                  <!-- Usar object en lugar de iframe -->
                  <object
                    [data]="pdfUrls[i]"
                    type="application/pdf"
                    width="100%"
                    height="600px"
                    class="pdf-object">
                    <p>
                      Su navegador no puede mostrar PDFs.
                      <button mat-raised-button color="primary" (click)="downloadFile(url, fileName[i])">
                        <mat-icon>download</mat-icon>
                        Descargar PDF
                      </button>
                    </p>
                  </object>
                  <div class="pdf-controls">
                    <span class="pdf-name">{{ fileName[i] }}</span>
                    <button mat-raised-button color="primary" (click)="downloadFile(url, fileName[i])">
                      <mat-icon>download</mat-icon>
                      Descargar
                    </button>
                  </div>
                </div>
              }
              <!-- Para imágenes -->
              @if (!pdfUrls[i]) {
                <div class="image-wrapper">
                  <img [src]="url" alt="Documento" class="document-image">
                  <div class="image-controls">
                    <span class="image-name">{{ fileName[i] }}</span>
                    <button mat-raised-button color="primary" (click)="downloadFile(url, fileName[i])">
                      <mat-icon>download</mat-icon>
                      Descargar
                    </button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </mat-dialog-content>
  }

  <div class="modal-footer">
    <button mat-raised-button class="background-danger" (click)="_close()">Cerrar</button>
    @if (data.type === 'upload') {
      <button
        mat-raised-button
        class="background-success"
        id="save_button"
        [disabled]="files.length === 0"
        (click)="_save()">
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    }
  </div>